import { Controller } from "stimulus";

export default class extends Controller {
   connect() {
      this.tag = "[EnrollmentContractAvaliationsController]";
      console.log(this.tag, "Connected");
   }

   update(evt) {
      try {
         console.log(this.tag, "Updating avaliation");
         const id = parseInt(evt.target.getAttribute("data-id"));

         if (id > 999999999999) {
            return;
         }

         const source = evt.target.getAttribute("data-source");
         const value  = evt.target.value;
         this.changeAvaliation(evt, id, source, value);
      } catch (e) {
         console.error(this.tag, "Error updating avaliation", e);
      }
   }

   add(evt) {
      try {
         console.log(this.tag, "Adding");
         const component = evt.target.dataset.component;
         const lesson    = evt.target.dataset.key;
         const key       = component + "_" + lesson;
         const template  = document.getElementById("avaliation_row_template");
         const container = document.getElementById("component_lesson_" + key + "_end");
         const content   = template.innerHTML.replace(/TEMPLATE_ID/g, new Date().valueOf())
            .replace(/COMPONENT_ID/g, component)
            .replace(/LESSON_ID/g, lesson);
         container.insertAdjacentHTML('beforebegin', content);
      } catch (e) {
         console.error(this.tag, "Error adding", e);
      }
   }

   remove(evt) {
      try {
         console.log(this.tag, "Removing");
         const id = evt.target.dataset.id;
         document.getElementById("resource_" + id + "_destroy").value = 1;
         document.getElementById("tr_" + id).style.display = "none";
      } catch (e) {
         console.error(this.tag, "Error removing", e);
      }
   }

   headers() {
      try {
         return {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
         };
      } catch (e) {
         console.error(this.tag, "Error on headers", e);
      }
   }

   async changeAvaliation(evt, id, source, value) {
      try {
         console.log(this.tag, "Changing avaliation");
         const contract = document.getElementById("update_avaliation_contract")?.value;
         const url      = `/admin/enrollments/contract/${contract}/update_avaliation`;
         const headers  = this.headers();
         const body     = JSON.stringify({ resource_id: id, resource: source, value: value });
         const response = await fetch(url, { method: 'PUT', body: body, headers: headers });

         if (!response.ok) {
            alert("Erro atualizando a avaliação");
            return;
         }

         const data = await response.json();
         console.log(this.tag, data);
      } catch (e) {
         evt.preventDefault();
         console.error(this.tag, "Error changing avaliation", e);
      }
   }
}
